<template>
<div class="nrs-header">

    <div class="nrs-container">

        <div class="nrs-header__logo">
            <img src="../assets/nrs-logo@2x.png" onclick="location.href='https://www.netroadshow.com'" />
        </div>

    </div>

</div>
</template>

<script>
export default {
  name: 'HeaderSimple',
};
</script>

<style lang="less" scoped>
*, :before, :after {
    box-sizing: border-box;
}

.nrs-header {
    box-shadow: 0 2px 3px -2px #ddd;
    border-bottom: 1px solid #ddd;
    background-color: #305a7a;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 73px;
    z-index: 600;
    width: 100%;
}

.nrs-container {
    max-width: 970px;
    width: 100%;
    height: 100%;
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px;
}

.nrs-header .nrs-container {
    display: table;
    padding-left: 5px;
    position: relative;
}

.nrs-header__logo {
    position: relative;
    display: table-cell;
    vertical-align: middle;
    padding-left: 10px;
    width: 305px;
    padding-right: 30px;
    padding-bottom: 2px;
}

.nrs-header__logo img {
    width: 100%;
    padding-left: 5px;
    max-width: 305px;
    vertical-align: middle;
}

.nrs-container {
    justify-content: center;
}

@media (max-width: 767px) {
    .nrs-header__logo {
        width: 100%;
    }

    .nrs-header__logo img {
        max-width: 220px;
    }
}
</style>
